import { render, staticRenderFns } from "./SelectStaffPopover.vue?vue&type=template&id=4904a77f&"
import script from "./SelectStaffPopover.vue?vue&type=script&lang=js&"
export * from "./SelectStaffPopover.vue?vue&type=script&lang=js&"
import style0 from "./SelectStaffPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports